export default __webpack_public_path__ + "img/DATABASE.2ae2b3d1.png";